import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';

interface DefaultBrandLogoProps {
  className?: string;
  size?: number;
}

export function DefaultBrandLogo({ className = '', size = 52 }: DefaultBrandLogoProps) {
  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      <svg width="100%" height="100%" viewBox="0 0 738 738" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
        <g filter="url(#filter0_i_3144_56799)">
          <rect width="738" height="738" rx="369" fill="#E1634A"/>
          <rect width="738" height="738" rx="369" fill="white" fillOpacity="0.1"/>
          <path d="M338.364 487.15C348.219 489.816 358.588 491.239 369.288 491.239C379.142 491.239 388.713 490.03 397.863 487.757L352.791 655.392L297.127 640.527L338.364 487.15ZM498.159 625.231L442.495 640.096L401.292 486.851C421.07 481.298 438.737 470.724 452.82 456.599L498.159 625.231ZM284.524 455.354C298.282 469.567 315.607 480.328 335.062 486.209L211.77 609.082L171.021 568.472L284.524 455.354ZM608.915 526.681L568.166 567.292L454.925 454.435C468.678 439.917 478.757 421.902 483.675 401.867L608.915 526.681ZM254.771 401.353C259.522 421.102 269.285 438.91 282.643 453.365L112.875 498.7L97.9609 443.227L254.771 401.353ZM482.128 339.869L655.387 386.136L640.473 441.609L484.144 399.863C486.039 391.505 487.044 382.807 487.044 373.878C487.044 362.04 485.283 350.612 482.012 339.838L482.128 339.869ZM255.43 340.514L256.286 340.742C253.189 351.251 251.525 362.371 251.525 373.878C251.525 382.746 252.516 391.384 254.386 399.69L82.6123 353.819L97.5273 298.347L255.43 340.514ZM338.468 259.637L338.703 260.515C299.32 271.041 268.084 301.408 256.444 340.207L255.912 339.677L129.085 213.279L169.834 172.669L285.431 287.872L286.75 289.188L286.267 287.389L239.845 114.733L295.511 99.8673L338.468 259.637ZM442.691 97.4796L400.332 255.035L399.849 256.834L401.168 255.519L526.232 130.879L566.98 171.488L451.389 286.69L450.064 288.009L451.87 287.526L625.123 241.261L640.039 296.734L482.128 338.903L481.756 339.002C466.853 291.215 422.134 256.518 369.284 256.518C358.899 256.518 348.827 257.859 339.234 260.375L339.434 259.637L387.027 82.6153L442.691 97.4796Z" fill="url(#paint0_linear_3144_56799)" fillOpacity="0.88" stroke="url(#paint1_linear_3144_56799)"/>
        </g>
        <defs>
          <filter id="filter0_i_3144_56799" x="0" y="-4" width="738" height="742" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="-4"/>
            <feGaussianBlur stdDeviation="4"/>
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"/>
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3144_56799"/>
          </filter>
          <linearGradient id="paint0_linear_3144_56799" x1="369" y1="82.004" x2="369" y2="952.392" gradientUnits="userSpaceOnUse">
            <stop offset="0.313079" stopColor="white"/>
            <stop offset="1" stopColor="white" stopOpacity="0"/>
          </linearGradient>
          <linearGradient id="paint1_linear_3144_56799" x1="1382.16" y1="-1311.16" x2="-306.687" y2="58.9074" gradientUnits="userSpaceOnUse">
            <stop stopColor="white"/>
            <stop offset="1" stopColor="white" stopOpacity="0"/>
          </linearGradient>
        </defs>
      </svg>

    </div>
  );
}

export default DefaultBrandLogo;


